/**
 * SF35 — Owner Pilot Release Checklist
 * मालिक pilot release checklist — ३ sample workflows और १० acceptance checks
 */
const SAMPLE_WORKFLOWS = Object.freeze([
    Object.freeze({
        workflowId: 'sample-01',
        name: 'kundali_audio_transcript_json',
        description: 'कुंडली audio transcript -> JSON',
        inputType: 'audio/mpeg',
        domainHint: 'kundali',
        expectedOutputFiles: Object.freeze(['transcript.txt', 'transcript.segments.json', 'kundali_vastu_extract.json', 'audit.json']),
        ownerApprovalRequired: true,
        noRawAudioCommitted: true,
        noProviderCallInCI: true,
    }),
    Object.freeze({
        workflowId: 'sample-02',
        name: 'vastu_video_transcript_json',
        description: 'वास्तु video transcript -> JSON',
        inputType: 'video/mp4',
        domainHint: 'vastu',
        expectedOutputFiles: Object.freeze(['transcript.txt', 'transcript.segments.json', 'kundali_vastu_extract.json', 'audit.json']),
        ownerApprovalRequired: true,
        noRawAudioCommitted: true,
        noProviderCallInCI: true,
    }),
    Object.freeze({
        workflowId: 'sample-03',
        name: 'youtube_transcript_checklist',
        description: 'general YouTube transcript -> checklist',
        inputType: 'youtube-caption',
        domainHint: 'general',
        expectedOutputFiles: Object.freeze(['transcript.txt', 'checklist.json', 'audit.json']),
        ownerApprovalRequired: true,
        noRawAudioCommitted: true,
        noProviderCallInCI: true,
    }),
]);
const ACCEPTANCE_CHECKS = Object.freeze([
    Object.freeze({ checkId: 'acc-01', description: 'no raw audio committed to repo', category: 'privacy' }),
    Object.freeze({ checkId: 'acc-02', description: 'no provider call in CI', category: 'safety' }),
    Object.freeze({ checkId: 'acc-03', description: 'owner-approved staging only for real transcription', category: 'approval' }),
    Object.freeze({ checkId: 'acc-04', description: 'transcript redaction before persist', category: 'privacy' }),
    Object.freeze({ checkId: 'acc-05', description: 'output files reproducible from transcript fixture', category: 'output' }),
    Object.freeze({ checkId: 'acc-06', description: 'rollback available after write', category: 'safety' }),
    Object.freeze({ checkId: 'acc-07', description: 'budget guard blocks over-limit calls', category: 'safety' }),
    Object.freeze({ checkId: 'acc-08', description: 'confidence and caution in kundali/vastu claims', category: 'output' }),
    Object.freeze({ checkId: 'acc-09', description: 'audit.json generated for every workflow', category: 'safety' }),
    Object.freeze({ checkId: 'acc-10', description: 'no medical/legal/financial guarantee in output', category: 'safety' }),
]);
export const OWNER_PILOT_RELEASE_CHECKLIST_SF35 = Object.freeze({
    version: '0.1.104',
    sampleWorkflows: SAMPLE_WORKFLOWS,
    acceptanceChecks: ACCEPTANCE_CHECKS,
    totalSampleWorkflows: SAMPLE_WORKFLOWS.length,
    totalAcceptanceChecks: ACCEPTANCE_CHECKS.length,
    noRawAudioCommitted: true,
    noProviderCallInCI: true,
    ownerApprovedStagingOnly: true,
    outputsReproducibleFromFixture: true,
});
//# sourceMappingURL=ownerPilotReleaseChecklistSf35.js.map